import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';
import CatalogConfiguratorAnalytics from '../../../_modules/google_analytics/catalog_configurator';
import RegoLookupAnalytics from '../../../_modules/google_analytics/rego_lookup';
import VehicleSelectorAnalytics from '../../../_modules/google_analytics/vehicle_selector';

function InfoLayer(props) {
  const staticUrl = props.staticUrl;
  const type = props.type || 'tyre_size';

  return (
    <section className="configurator-info-layer catalog-configurator-section">
      <img
        className="img-responsive"
        alt="tyre-size-help"
        src={staticUrl + 'images/catalog/tyre-size-help-image_new.jpg'}
      />
      <p className="configurator-info-layer__note">
        <Translation translationKey={'catalog-configurator-second-layer-header-info-layer-more-notes'} />
      </p>
      <img
        className="img-responsive"
        alt="tyre-placard"
        style={{ marginBottom: '20px' }}
        src={staticUrl + 'images/catalog/tyre-placard.png'}
      />
      <button
        className="configurator-info-layer__continue"
        onClick={() => {
          if (type === 'rego') {
            RegoLookupAnalytics.goToFormAction();
          } else if (type === 'vehicle') {
            VehicleSelectorAnalytics.goToFormAction();
          } else {
            CatalogConfiguratorAnalytics.goToFormAction();
          }
          props.onBackClick();
        }}
      >
        Ok, got it!
      </button>
    </section>
  );
}

InfoLayer.propTypes = {
  staticUrl: PropTypes.string.isRequired,
  onShowSecondLayerClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
};

export default InfoLayer;
